export interface IViewIgsBillingContactInfoScope extends ng.IScope {
        viewIgsBillingContactInfoCtrl: ViewIgsBillingContactInfoController;
    }

    export class ViewIgsBillingContactInfoController {
        public static $inject = ['$scope', '$modalInstance'];
        constructor(
            public $scope: IViewIgsBillingContactInfoScope,
            public $modalInstance: angular.ui.bootstrap.IModalServiceInstance) {

            $scope.viewIgsBillingContactInfoCtrl = this;

        }

        public closeModal = () => {
            this.$modalInstance.close();
        }

    }
